import {User, WorkspaceMember} from "../../lib/types";
import {useUserContext} from "../../providers/UserContext";

export const UserName: React.FC<{ user: User | WorkspaceMember, firstNameOnly?: boolean }> = ({ user, firstNameOnly = true }) => {
  const { user: me } = useUserContext();
  const displayName = user.id === me?.uid ? "You" : (firstNameOnly ? user.displayName.split(' ')[0] : user.displayName);
  return (
    <span>{displayName}</span>
  );
}